export default "__VITE_ASSET__05373801__"